import { useState, useEffect } from "react";
import NavBar from "../../components/navBar/navBar";
import { toast } from "react-toastify";
import CreateSurvey from "./CreateSurvey";
import useGetSurveys from "../../hooks/useGetSurveys";
import useDeleteSurveyMutation from "../../hooks/useDeleteSurveyMutation";
import CustomButton from "../UI/CustomButton";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const SurveyPoem = ({ setAddNewSurvey, AllSurveyData, trial_detail }) => {
  const [surveyId, setSurveyId] = useState(0);
  const [survey, setSurvey] = useState({
    question: [],
  });
  const [Loader, setLoader] = useState(false);
  const [tabChanged, settabChanged] = useState(false);
  const [activeTab, setActiveTab] = useState("viewCase");
  const [questionCount, setQuestionCount] = useState([1]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const { data: surveyList, isLoading, refetch: refetchSurveys, isSuccess } = useGetSurveys();
  const deleteSurveyMutation = useDeleteSurveyMutation();

  useEffect(() => {
    if (trial_detail) {
      setActiveTab("addSurvey");
    }
  }, []);

  useEffect(() => {
    if (isSuccess && AllSurveyData) {
      AllSurveyData();
    }
  }, [isSuccess]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setSurveyId(0);
    settabChanged(false);
    setSurvey((previous) => ({
      ...previous,
      name: "",
      type: "",
      available: "",
      question: [],
    }));
    setQuestionCount([1]);
  };

  const handleRowClick = (id) => {
    setSurveyId(id);
    setActiveTab("addSurvey");
    settabChanged(true);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setOpenConfirm(true);
  };

  const confirmDelete = () => {
    deleteSurveyMutation.mutate(deleteId, {
      onSuccess: () => {
        toast.success("Successfully deleted the survey.");
        setOpenConfirm(false);
      },
      onError: () => {
        toast.error("Error deleting survey.");
        setOpenConfirm(false);
      },
    });
  };

  return (
    <Box sx={{ maxWidth: "95%", mx: "auto" }}>
      {trial_detail ? null : <NavBar active="survey" />}
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
            py: 2,
            width: "100%",
          }}
        >
          <Stack direction="row" spacing={1}>
            {!trial_detail && (
              <Button
                variant={activeTab === "viewCase" ? "contained" : "outlined"}
                size="small"
                onClick={() => handleTabClick("viewCase")}
              >
                View Survey
              </Button>
            )}
            <Button
              variant={activeTab === "addSurvey" ? "contained" : "outlined"}
              size="small"
              disabled={tabChanged}
              onClick={() => handleTabClick("addSurvey")}
            >
              {surveyId ? "Edit Survey" : "Add Survey"}
            </Button>
          </Stack>
        </Box>

        {activeTab === "addSurvey" ? (
          <CreateSurvey
            GetSurveys={refetchSurveys}
            toast={toast}
            survey={survey}
            setSurvey={setSurvey}
            setActiveTab={setActiveTab}
            surveyId={surveyId}
            setSurveyId={setSurveyId}
            activeTab={activeTab}
            setQuestionCount={setQuestionCount}
            questionCount={questionCount}
            settabChanged={settabChanged}
            setAddNewSurvey={setAddNewSurvey}
            setLoader={setLoader}
          />
        ) : (
          <>
            {Loader || isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50vh",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Available</TableCell>
                      <TableCell>Created at</TableCell>
                      <TableCell>Trials</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {surveyList?.map((data, index) => (
                      <TableRow
                        key={index}
                        hover
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleRowClick(data.id)}
                      >
                        <TableCell sx={{ whiteSpace: "pre-wrap" }}>{data?.name}</TableCell>
                        <TableCell>{data?.type}</TableCell>
                        <TableCell>{data?.available ? "True" : "False"}</TableCell>
                        <TableCell>
                          {new Date(data.created_at + "Z").toDateString()},{" "}
                          {new Date(data.created_at + "Z").toLocaleTimeString()}
                        </TableCell>
                        <TableCell>{data?.trials.map((trial) => trial.name).join(", ")}</TableCell>
                        <TableCell>
                          <CustomButton
                            size="small"
                            className={`delete-${data?.name.replaceAll(" ", "_")}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(data.id);
                            }}
                          >
                            Delete Survey
                          </CustomButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </Box>

      {/* Confirmation Dialog */}
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this survey? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)}>Cancel</Button>
          <Button
            onClick={confirmDelete}
            color="error"
            variant="contained"
            className="confirm-delete"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SurveyPoem;
